export function getEntities() {
  return [
  {
    "Entities": [
      {
        "Score": 0.7631785869598389,
        "Type": "EVENT",
        "Text": "SIIM",
        "BeginOffset": 11,
        "EndOffset": 15
      },
      {
        "Score": 0.4611854553222656,
        "Type": "DATE",
        "Text": "2020",
        "BeginOffset": 16,
        "EndOffset": 20
      },
      {
        "Score": 0.9994515776634216,
        "Type": "DATE",
        "Text": "2011",
        "BeginOffset": 41,
        "EndOffset": 45
      },
      {
        "Score": 0.999603271484375,
        "Type": "PERSON",
        "Text": "Tim O. Connor",
        "BeginOffset": 109,
        "EndOffset": 122
      },
      {
        "Score": 0.8770829439163208,
        "Type": "PERSON",
        "Text": "Director",
        "BeginOffset": 124,
        "EndOffset": 132
      },
      {
        "Score": 0.9956516027450562,
        "Type": "ORGANIZATION",
        "Text": "Cincinnati Children's Hospital Medical Center",
        "BeginOffset": 162,
        "EndOffset": 207
      },
      {
        "Score": 0.9476798176765442,
        "Type": "QUANTITY",
        "Text": "three",
        "BeginOffset": 439,
        "EndOffset": 444
      },
      {
        "Score": 0.7686042785644531,
        "Type": "QUANTITY",
        "Text": "three very",
        "BeginOffset": 477,
        "EndOffset": 487
      },
      {
        "Score": 0.6726427674293518,
        "Type": "QUANTITY",
        "Text": "talks",
        "BeginOffset": 500,
        "EndOffset": 505
      },
      {
        "Score": 0.9320529699325562,
        "Type": "QUANTITY",
        "Text": "first speaker",
        "BeginOffset": 511,
        "EndOffset": 524
      },
      {
        "Score": 0.8801817297935486,
        "Type": "PERSON",
        "Text": "Dr.",
        "BeginOffset": 528,
        "EndOffset": 531
      },
      {
        "Score": 0.9990664720535278,
        "Type": "PERSON",
        "Text": "Tessa Cook",
        "BeginOffset": 532,
        "EndOffset": 542
      },
      {
        "Score": 0.9988773465156555,
        "Type": "PERSON",
        "Text": "Tessa",
        "BeginOffset": 578,
        "EndOffset": 583
      }
    ],
    "speaker": "spk_0",
    "chunkText": "Welcome to SIIM 2020. This is course Id  2011, Leveraging Technology to Improve the Patient Experience. I am Tim O. Connor, Director of Radiology Informatics  at Cincinnati Children's Hospital Medical Center. I think we can all agree that the engagement with our patients and their families is key to creating a healthy environment, an important driver and overall patient satisfaction. During this session, we're going to be hearing from three very exceptional speakers doing three very interesting talks. Our first speaker is Dr. Tessa Cook so I'll turn the presentation over Tessa.   Hello everyone. I'm delighted to share our experience"
  },
  {
    "Entities": [],
    "speaker": "spk_1",
    "chunkText": "in using  infomatics and IT to  improve lines of communication between patients and their care teams. I have some disclosures, mostly related to leadership roles that I hold in various radiology societies, as well as related to some grant funding for research and development."
  },
  {
    "Entities": [
      {
        "Score": 0.9967851042747498,
        "Type": "QUANTITY",
        "Text": "three initiatives",
        "BeginOffset": 147,
        "EndOffset": 164
      }
    ],
    "speaker": "spk_1",
    "chunkText": "So, in my portion of the presentation of them, talk a little bit about why we chose to focus on physician patient communication and share with you three initiatives that are currently ongoing in my department to improve the outpatient radiology experience,  streamline communication between the emergency department and radiology, and address some of the positioning patient barriers to completing imaging basics through."
  },
  {
    "Entities": [
      {
        "Score": 0.981360673904419,
        "Type": "QUANTITY",
        "Text": "one reason",
        "BeginOffset": 178,
        "EndOffset": 188
      }
    ],
    "speaker": "spk_1",
    "chunkText": "As physicians, we want to communicate with our patients and always like to think that we do so in a way that is direct and clear. But in reality, the message make it garbled for one reason or another, or patients may get overwhelmed with too much information, or sometimes they may not get nearly as much information as they would like to have and so despite our best efforts, our patients may end up confused or still having more questions."
  },
  {
    "Entities": [],
    "speaker": "spk_1",
    "chunkText": "Additionally, when we have in person patient interactions, physicians often have to fit a number of discussion points into a very short period of time or whether it's in person or in telehealth visits, as many physicians are currently doing, some thingsmay  have to take priority over others, and the discussion points that fall further down on the list may never get to be discussed if they continue to fall lower and lower compared to other high priority items. And so as we thought about these different challenges, we wanted to consider specific situations"
  },
  {
    "Entities": [
      {
        "Score": 0.6090990900993347,
        "Type": "QUANTITY",
        "Text": "three",
        "BeginOffset": 159,
        "EndOffset": 164
      },
      {
        "Score": 0.8005909323692322,
        "Type": "QUANTITY",
        "Text": "first",
        "BeginOffset": 258,
        "EndOffset": 263
      }
    ],
    "speaker": "spk_1",
    "chunkText": "in radiology where we could help to improve communication between patients and physicians or at least even related to radiology imaging.  And so we identified three areas of interestand I'm going to tell you a little about a little about in more detail. The first was helping to set patient's expectations for when they came for an outpatient imaging exam. The next was helping to provide better information or, more easily available information to physicians caring for patients in acute setting, such as in the ED  to aid in the speed of the workup  on the decision making and finally to improve education and stimulate conversation about the importance of imaging based screens."
  },
  {
    "Entities": [
      {
        "Score": 0.9890660047531128,
        "Type": "QUANTITY",
        "Text": "two of these ideas",
        "BeginOffset": 4,
        "EndOffset": 22
      },
      {
        "Score": 0.9237289428710938,
        "Type": "DATE",
        "Text": "last year",
        "BeginOffset": 95,
        "EndOffset": 104
      },
      {
        "Score": 0.9981773495674133,
        "Type": "ORGANIZATION",
        "Text": "Center for Practice Transformation",
        "BeginOffset": 123,
        "EndOffset": 157
      },
      {
        "Score": 0.9378882646560669,
        "Type": "ORGANIZATION",
        "Text": "Department of Radiology",
        "BeginOffset": 200,
        "EndOffset": 223
      },
      {
        "Score": 0.9988652467727661,
        "Type": "QUANTITY",
        "Text": "30 ideas",
        "BeginOffset": 245,
        "EndOffset": 253
      },
      {
        "Score": 0.9959628582000732,
        "Type": "QUANTITY",
        "Text": "10 semifinalists",
        "BeginOffset": 264,
        "EndOffset": 280
      },
      {
        "Score": 0.9978909492492676,
        "Type": "QUANTITY",
        "Text": "two winners",
        "BeginOffset": 285,
        "EndOffset": 296
      }
    ],
    "speaker": "spk_1",
    "chunkText": "So, two of these ideas actually came out of our departmental innovation challenge that we held last year, sponsored by our Center for Practice Transformation which is our innovation center within the Department of Radiology. We started out with 30 ideas. We chose 10 semifinalists and two winners,"
  },
  {
    "Entities": [
      {
        "Score": 0.8733060359954834,
        "Type": "QUANTITY",
        "Text": "a number of the other ideas",
        "BeginOffset": 31,
        "EndOffset": 58
      }
    ],
    "speaker": "spk_1",
    "chunkText": "and we also tried to implement a number of the other ideas because so many of them were such great suggestions that they didn't require the resources of the entire center or a months to year long pilot period to actually make them happen."
  },
  {
    "Entities": [
      {
        "Score": 0.9567083120346069,
        "Type": "QUANTITY",
        "Text": "first",
        "BeginOffset": 11,
        "EndOffset": 16
      },
      {
        "Score": 0.9240368604660034,
        "Type": "QUANTITY",
        "Text": "two ideas",
        "BeginOffset": 26,
        "EndOffset": 35
      },
      {
        "Score": 0.9965984225273132,
        "Type": "QUANTITY",
        "Text": "two",
        "BeginOffset": 92,
        "EndOffset": 95
      },
      {
        "Score": 0.9998971223831177,
        "Type": "PERSON",
        "Text": "Michael Schreiber",
        "BeginOffset": 140,
        "EndOffset": 157
      },
      {
        "Score": 0.9987817406654358,
        "Type": "PERSON",
        "Text": "Gregory Middle",
        "BeginOffset": 162,
        "EndOffset": 176
      }
    ],
    "speaker": "spk_1",
    "chunkText": "And so the first of these two ideas centred around the outpatient radiology experience. And two of our current radiology residents, doctors Michael Schreiber and Gregory Middle, notice that every time they went over to the outpatient center, the waiting room was always full. And oftentimes there was this crowd of people right at the entrance to the registration area. And we started joking about the fact that, you know, it looks like a bus. It just let off. And all the sudden there was this crowd of people standing there. Well, what do you know come to find out it really was a bus. It was the shuttle bus from the parking garage that would pick up patients there, bring them to the outpatient center and then drop off its passengers. And so not surprisingly, a large number of them were coming to radiology, and it really was this busload of people that had been dropped off all at the same time. And so we showed it to think about whether we could address some of the communication that was needed when the patients showed up at that registration desk ahead of time so that they didn't all have to stand there in the crowd in a line waiting to do whatever it is they needed to do. And as we started to look at the overall registration and outpatient radiology experience, we came up with a whole series of questions that patients might have. This is just a short list,"
  },
  {
    "Entities": [
      {
        "Score": 0.9566870331764221,
        "Type": "QUANTITY",
        "Text": "first three",
        "BeginOffset": 93,
        "EndOffset": 104
      },
      {
        "Score": 0.9816024899482727,
        "Type": "PERSON",
        "Text": "Jones",
        "BeginOffset": 1174,
        "EndOffset": 1179
      },
      {
        "Score": 0.5935900211334229,
        "Type": "ORGANIZATION",
        "Text": "Covid19",
        "BeginOffset": 1938,
        "EndOffset": 1945
      },
      {
        "Score": 0.731619119644165,
        "Type": "ORGANIZATION",
        "Text": "SIIM",
        "BeginOffset": 2186,
        "EndOffset": 2190
      },
      {
        "Score": 0.9810844659805298,
        "Type": "DATE",
        "Text": "next year",
        "BeginOffset": 2192,
        "EndOffset": 2201
      }
    ],
    "speaker": "spk_1",
    "chunkText": "and we started to dig a little bit deeper into into some of these questions. We realized the first three you know, we're pretty well taken care of by the instructions that patients received prior to their appointment. Ah, and so we started to look into the patients who ended up waiting disproportionately longer for their exam and what some of those reasons were because, not surprisingly, waiting a really long time after you showed up for your imaging appointment was associated with lower satisfaction, and some of this was related to the availability of the script for the examination. Some of this was related to the pre certification needs, and we actually followed this path for quite some time to try to figure out a solution, and then ultimately realized that there was a team of people already working on this since in the Enterprise. And so since this issue is sort of being addressed we started to focus on what the patients experienced when they actually got to outpatient radiology in terms of what they would have to do, the very steps to prepare for the exam and then the test itself. And so we set up a set of communications with patients to say, Dear Mrs Jones, you're coming for your ultrasoundof the pelvis on this date. Here's what you can expect when you arrive and everything from this is where the waiting room is. This is what it will look like when you go back to the changing area. How to actually dress for the examination? Any preparatory steps such as not relevant in ultrasound but oral contrast if relevant, special diets. Ah, and then we tried to figure out creative ways of communicating this information to the patient, via the patient portal  in a text message through an email and then also toyed with different amounts of detail in different styles of messages. And so we were all keyed up to pilot all of this. And then the vast majority of our outpatient appointments got postponed because of the Covid19   &nbsp;pandemic  . And so now &nbsp; we're coming out the other side a little bit and we're starting to open up &nbsp;some of these appointments were getting ready to actually run our series  of pilots, and hopefully, when we come back to SIIM  next year, I can tell you what we learned."
  },
  {
    "Entities": [
      {
        "Score": 0.9875494241714478,
        "Type": "QUANTITY",
        "Text": "first initiative",
        "BeginOffset": 16,
        "EndOffset": 32
      },
      {
        "Score": 0.9641709327697754,
        "Type": "QUANTITY",
        "Text": "second",
        "BeginOffset": 38,
        "EndOffset": 44
      },
      {
        "Score": 0.6594012379646301,
        "Type": "PERSON",
        "Text": "Dr",
        "BeginOffset": 95,
        "EndOffset": 97
      },
      {
        "Score": 0.9919807314872742,
        "Type": "PERSON",
        "Text": "Ali Denaliwala",
        "BeginOffset": 98,
        "EndOffset": 112
      },
      {
        "Score": 0.9836745262145996,
        "Type": "QUANTITY",
        "Text": "two departments",
        "BeginOffset": 1047,
        "EndOffset": 1062
      },
      {
        "Score": 0.8035402894020081,
        "Type": "QUANTITY",
        "Text": "both sides",
        "BeginOffset": 1379,
        "EndOffset": 1389
      }
    ],
    "speaker": "spk_1",
    "chunkText": "So that was the first initiative. The second was another idea from another radiology resident, Dr Ali Denaliwala , looking at streamlining communication between radiology and the emergency department, particularly off hours. And right now, most of that communication almost all of that communication and back happens by phone. And the ED  is calling to try to figure out where their patients are in the pipeline of having their imaging ordered to having their imaging completed to having an interpretation generated. And as the call shift wears on, the number of phone calls tends to increase. And this is right now really the only way that our ED residents can communicate with our radiology resident, and they have mutually, uh, common goals. The the ED wants to figure out how to appropriately take care of these patients. Do they get admitted? Do they get treated and discharged? But they get discharged and radiology also wants to deliver good care. So with these common goals in mind, we figured that the more effectively we could get these two departments to communicate, the better the experience of the patient on the other side, waiting for some sort of information as to what happens to them next. Why their imaging is taking longer or why their interpretation might be taking longer than they might expect. Ah, and phone calls were just inefficient and disruptive on both sides of this interaction. And so, in an effort to ultimately assist with improving the emergency departments ability to move their patients to their next destination, we created in collaboration with them a set of dashboards. So there's one that lives in the emergency department, and there's one that lives in the radiology reading,"
  },
  {
    "Entities": [
      {
        "Score": 0.9459757208824158,
        "Type": "QUANTITY",
        "Text": "two residency programs",
        "BeginOffset": 566,
        "EndOffset": 588
      },
      {
        "Score": 0.9994928240776062,
        "Type": "DATE",
        "Text": "July 1st",
        "BeginOffset": 625,
        "EndOffset": 633
      }
    ],
    "speaker": "spk_1",
    "chunkText": "and we asked the our colleagues of it in the ED . You know, what is it that where your questions what? What do you want to know? When it's the middle of the night and you're picking up the phone to call radiology? Why are you typically calling and is this information that we can provide you in a different fashion to save you a phone call and to actually make it easier when you do need to call us to figure out where we are. So there were a number of common questions that they wanted answered, and we actually have, ah, big change coming in our residency are the two residency programs in our health system emerging as of July 1st, which is pretty soon. And so what may happen at that point is that the resident reading the exam or that during the day the radiologist reading the exam won't necessarily be in the same hospital as the one where the patient was imaged and so we certainly don't want are referring colleagues to have to keep calling multiple different reading rooms until they find the person that they want. And so we were able to communicate information about where patients were in the queue. Expected turnaround times, is radiology running ahead or behind schedule? Ah, and where is the person that is reading your exam and how do you reach them?"
  },
  {
    "Entities": [
      {
        "Score": 0.5868308544158936,
        "Type": "ORGANIZATION",
        "Text": "Covid",
        "BeginOffset": 330,
        "EndOffset": 335
      },
      {
        "Score": 0.9971444606781006,
        "Type": "QUANTITY",
        "Text": "two departments",
        "BeginOffset": 659,
        "EndOffset": 674
      }
    ],
    "speaker": "spk_1",
    "chunkText": "So again, we were gearing up for this pilot. We were going to expand system wide after we implemented our lessons learned, but a lot of the resources  of the emergency department got diverted, uh, due to the pandemic. But actually now is we're sort of stabilized and starting to look at what practice looks like in the setting of Covid. We're starting to realize how important it is to be able to communicate this type of information to patients and to help them understand the bigger picture of their of their disposition. And so we're really excited to figure out how these dashboards impact practice during off hours for end this communication between the two departments."
  },
  {
    "Entities": [
      {
        "Score": 0.611447811126709,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 60,
        "EndOffset": 63
      },
      {
        "Score": 0.4847758114337921,
        "Type": "OTHER",
        "Text": "4003",
        "BeginOffset": 133,
        "EndOffset": 137
      },
      {
        "Score": 0.7288795113563538,
        "Type": "OTHER",
        "Text": "hipatocellular carcinoma",
        "BeginOffset": 295,
        "EndOffset": 319
      },
      {
        "Score": 0.790593147277832,
        "Type": "QUANTITY",
        "Text": "twice a year",
        "BeginOffset": 558,
        "EndOffset": 570
      },
      {
        "Score": 0.9960677623748779,
        "Type": "QUANTITY",
        "Text": "5 year",
        "BeginOffset": 634,
        "EndOffset": 640
      },
      {
        "Score": 0.9967132806777954,
        "Type": "QUANTITY",
        "Text": "5 year",
        "BeginOffset": 755,
        "EndOffset": 761
      },
      {
        "Score": 0.8374075293540955,
        "Type": "QUANTITY",
        "Text": "more than half of",
        "BeginOffset": 833,
        "EndOffset": 850
      },
      {
        "Score": 0.8629926443099976,
        "Type": "QUANTITY",
        "Text": "both",
        "BeginOffset": 1172,
        "EndOffset": 1176
      }
    ],
    "speaker": "spk_1",
    "chunkText": "So the last initiative that I'll tell you about is actually one that I talk about in more detail in a scientific presentation number 4003   . So if this is of interest in the short version here, please check out that presentation as well. And this has to do with increasing screening rates for  hipatocellular carcinoma HCC, which is a kind of liver cancer with a number of associative risk factors. And so what we wanted to do was creatively use the EMR to help to get more of these patients to their recommended screening, which is an abdominal ultrasound twice a year. And why even bother doing this ... well for HCC we know that, 5 year  survival decreases as you go towards more advanced  disease. Uh, and if you're diagnosed at the late stage, your 5 year survival is is extremely low. But yet we know that from the literature more than half of these patients are actually diagnosed at that late stage. And if we were to increase the number of screening rates, we would ideally push this graph further towards the left and improve the number of earlier stage diagnoses that are potentially treatable. And so, as we looked at this problem, we noticed that there were both physician related barriers and patient related barriers for getting screenings ordered and completed. And so we wanted to intervene to actually address some of those."
  },
  {
    "Entities": [
      {
        "Score": 0.8897367715835571,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 44,
        "EndOffset": 47
      },
      {
        "Score": 0.9023565053939819,
        "Type": "QUANTITY",
        "Text": "first thing",
        "BeginOffset": 452,
        "EndOffset": 463
      },
      {
        "Score": 0.6666447520256042,
        "Type": "QUANTITY",
        "Text": "about six months",
        "BeginOffset": 649,
        "EndOffset": 665
      },
      {
        "Score": 0.931971549987793,
        "Type": "QUANTITY",
        "Text": "40 years old",
        "BeginOffset": 776,
        "EndOffset": 788
      },
      {
        "Score": 0.793316662311554,
        "Type": "QUANTITY",
        "Text": "40",
        "BeginOffset": 891,
        "EndOffset": 893
      },
      {
        "Score": 0.8632489442825317,
        "Type": "QUANTITY",
        "Text": "two dozen",
        "BeginOffset": 963,
        "EndOffset": 972
      }
    ],
    "speaker": "spk_1",
    "chunkText": "So particularly for the physician barriers, one of the hardest things we noticed and in this is in the population of primary care physicians. Caring for these patients is that it was really hard to figure out in a short visit to remember that the patient was at risk to figure out that they hadn't had their screening and to order that screening and then have a conversation with the patient about why it was important to get the screening. And so the first thing that we wanted to do was make this an easier lift for our primary care colleagues. And we developed a query, actually identify these patients, and this was actually it took us probably about six months to really refine this, because this is not a simple screening mammography, where if you're a woman and you're 40 years old and you're following the the radiology recommendation that you start annual mammography at the age of 40 that's it. That's that. Those are the criteria. But there are almost two dozen criteria here that need to be taken into account for HCC screening. And so we developed that query. We used it to find patients with upcoming primary care appointments and create upended order for their screening ultrasound if they if they were due for screening or overdue, for screening by attaching that order to the upcoming encounter in the medical record, as soon as the primary care physician opened up that encounter, they would see the order. They would see why it was there. There was a lot of detail provided, and they would be able to either sign the order, and then that would prompt a conversation with the patient about the need for screening or if they felt that the order was inappropriate for summaries and they could cancel it. And then we would follow up to figure out why."
  },
  {
    "Entities": [
      {
        "Score": 0.9054171442985535,
        "Type": "DATE",
        "Text": "January of last year January 1st of 2019",
        "BeginOffset": 74,
        "EndOffset": 114
      },
      {
        "Score": 0.9853015542030334,
        "Type": "QUANTITY",
        "Text": "seven funnel plots",
        "BeginOffset": 120,
        "EndOffset": 138
      },
      {
        "Score": 0.8139772415161133,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 190,
        "EndOffset": 193
      },
      {
        "Score": 0.9507817029953003,
        "Type": "QUANTITY",
        "Text": "first row",
        "BeginOffset": 266,
        "EndOffset": 275
      },
      {
        "Score": 0.994498074054718,
        "Type": "QUANTITY",
        "Text": "seven practices",
        "BeginOffset": 562,
        "EndOffset": 577
      }
    ],
    "speaker": "spk_1",
    "chunkText": "So just to give you a sense, we benchmark this against baseline data from January of last year January 1st of 2019. The seven funnel plots here are they intervention practices in green, the one in orange is the control practice. And to orient you to the funnel, the first row is patients at risk. Then you have patients with screenings ordered and then finally, patients that's readings completed and you'll notice before the intervention, there was a big drop here between patients at risk, and patients have got screenings order much less of a drop across the seven practices, even between screening ordered and screening completed and then"
  },
  {
    "Entities": [
      {
        "Score": 0.9982499480247498,
        "Type": "DATE",
        "Text": "August",
        "BeginOffset": 77,
        "EndOffset": 83
      },
      {
        "Score": 0.9888868927955627,
        "Type": "DATE",
        "Text": "December of 2019",
        "BeginOffset": 88,
        "EndOffset": 104
      },
      {
        "Score": 0.9997161626815796,
        "Type": "DATE",
        "Text": "May 25th",
        "BeginOffset": 136,
        "EndOffset": 144
      },
      {
        "Score": 0.920941174030304,
        "Type": "QUANTITY",
        "Text": "15%",
        "BeginOffset": 311,
        "EndOffset": 314
      },
      {
        "Score": 0.8612151741981506,
        "Type": "QUANTITY",
        "Text": "50% points",
        "BeginOffset": 332,
        "EndOffset": 342
      },
      {
        "Score": 0.9233348369598389,
        "Type": "ORGANIZATION",
        "Text": "Covid",
        "BeginOffset": 941,
        "EndOffset": 946
      },
      {
        "Score": 0.3611837923526764,
        "Type": "DATE",
        "Text": "two",
        "BeginOffset": 996,
        "EndOffset": 999
      },
      {
        "Score": 0.5875413417816162,
        "Type": "QUANTITY",
        "Text": "months",
        "BeginOffset": 1000,
        "EndOffset": 1006
      }
    ],
    "speaker": "spk_1",
    "chunkText": "after the intervention. So we started to create these pending orders between August and December of 2019 and looking at live data as of May 25th we again have patients at risk here of the top, but you'll notice that the number of patients with screenings ordered has significantly increased anywhere from about 15% points to almost 50% points higher than the baseline. Ah, and the control practice pretty much the same. Now, what you're probably also noticing is that there's a bigger drop between patients with screenings ordered and patients with screenings completed. And so while our early pilots did explore this a little bit, we know that there still a patient related factors anything from cost to accessibility to transportation to convenience that are going to affect whether or not patients get their screenings completed. Uh, however, part of this is also due to the fact that a lot of screening appointments got postponed due to Covid. So we were actually doing very well as of about two months before this. But I have been relatively static since then and expect to pick up from there."
  },
  {
    "Entities": [
      {
        "Score": 0.5534769296646118,
        "Type": "QUANTITY",
        "Text": "number of challenges",
        "BeginOffset": 19,
        "EndOffset": 39
      },
      {
        "Score": 0.9867225885391235,
        "Type": "ORGANIZATION",
        "Text": "Enterprise 80",
        "BeginOffset": 396,
        "EndOffset": 409
      },
      {
        "Score": 0.7341942191123962,
        "Type": "QUANTITY",
        "Text": "each of the individual",
        "BeginOffset": 454,
        "EndOffset": 476
      },
      {
        "Score": 0.8681855201721191,
        "Type": "QUANTITY",
        "Text": "more than six months",
        "BeginOffset": 763,
        "EndOffset": 783
      },
      {
        "Score": 0.9736223816871643,
        "Type": "QUANTITY",
        "Text": "seven primary care practices",
        "BeginOffset": 793,
        "EndOffset": 821
      }
    ],
    "speaker": "spk_1",
    "chunkText": "We did encounter a number of challenges as we were trying to implement this. I mentioned it took us a long time to come up with the baseline query because there was no pre-existing registry in the EMR  to do this because of that, we had to do a lot of build outside the EMR and that affected acceptance of this initiative by enterprise IT . We had to go through a number of governance groups for Enterprise 80 and then also had a number of meetings with each of the individual practices to gain their acceptance to trial this initiative once they were on board, they actually loved it. But it took them a while because they wanted to make sure that we weren't creating more work for them, where in fact, we were trying to create less work for them. Yeah, it took more than six months on board seven primary care practices, partly because of all of this, all of these upstream challenges. But it really taught us a lot about the importance of understanding our organizational culture and finding champions to support our efforts and also identifying areas of friction that we could mitigate early on."
  },
  {
    "Entities": [
      {
        "Score": 0.9494255781173706,
        "Type": "ORGANIZATION",
        "Text": "Twitter",
        "BeginOffset": 555,
        "EndOffset": 562
      },
      {
        "Score": 0.998503565788269,
        "Type": "PERSON",
        "Text": "Morgan McBee",
        "BeginOffset": 621,
        "EndOffset": 633
      }
    ],
    "speaker": "spk_1",
    "chunkText": "So in conclusion, we can use infomatics    in very creative ways, to improve the way that our patients can communicate with their physicians and ultimately that it should improve patient care and hopefully we'll also improve the patient experience. And we found that where possible, it was better to adapt existing technology rather than build build from scratch. Ah, and understanding the organizations culture was was very important to the success of our initiatives. Thank you so much for your interest in this presentation. You can reach out to me by Twitter or by email, if you have any questions. And up next is Dr Morgan McBee, who's gonna talk about directly communicating with patients to improve the patient experience."
  },
  {
    "Entities": [],
    "speaker": "spk_1",
    "chunkText": "Why, thank you."
  },
  {
    "Entities": [],
    "speaker": "spk_1",
    "chunkText": "You couldn't see me standing."
  },
  {
    "Entities": [
      {
        "Score": 0.9999531507492065,
        "Type": "PERSON",
        "Text": "Tessa",
        "BeginOffset": 17,
        "EndOffset": 22
      },
      {
        "Score": 0.999849259853363,
        "Type": "PERSON",
        "Text": "Morgan McBee",
        "BeginOffset": 38,
        "EndOffset": 50
      },
      {
        "Score": 0.7984714508056641,
        "Type": "ORGANIZATION",
        "Text": "Medical University of South Carolina",
        "BeginOffset": 115,
        "EndOffset": 151
      }
    ],
    "speaker": "spk_0",
    "chunkText": "Okay. Thank you, Tessa. So my name is Morgan McBee. I am a pediatric radiologist and imaging infomaticist   at the Medical University of South Carolina. And I'm gonna be talking about utilizing technology to directly communicate with patients."
  },
  {
    "Entities": [],
    "speaker": "spk_0",
    "chunkText": "I have no disclosures."
  },
  {
    "Entities": [
      {
        "Score": 0.9656646251678467,
        "Type": "DATE",
        "Text": "today",
        "BeginOffset": 31,
        "EndOffset": 36
      },
      {
        "Score": 0.6704742312431335,
        "Type": "QUANTITY",
        "Text": "first",
        "BeginOffset": 49,
        "EndOffset": 54
      },
      {
        "Score": 0.5627850890159607,
        "Type": "QUANTITY",
        "Text": "a couple",
        "BeginOffset": 212,
        "EndOffset": 220
      }
    ],
    "speaker": "spk_0",
    "chunkText": "And so what I'm going to cover today is, um, I'm first going to go over patient centered care and talk about why radiologist communicating with patients is actually a good idea and a good thing. And then go over a couple of different available options that allow radiologists to communicate with patients and then finally describe our implementation of a patient portal messaging system and what we have found so far."
  },
  {
    "Entities": [
      {
        "Score": 0.5671353340148926,
        "Type": "TITLE",
        "Text": "ACR",
        "BeginOffset": 225,
        "EndOffset": 228
      },
      {
        "Score": 0.614621639251709,
        "Type": "COMMERCIAL_ITEM",
        "Text": "Imaging",
        "BeginOffset": 231,
        "EndOffset": 238
      },
      {
        "Score": 0.37376394867897034,
        "Type": "TITLE",
        "Text": "3.0",
        "BeginOffset": 239,
        "EndOffset": 242
      },
      {
        "Score": 0.46293991804122925,
        "Type": "ORGANIZATION",
        "Text": "RSNA Radiology Cares",
        "BeginOffset": 247,
        "EndOffset": 267
      }
    ],
    "speaker": "spk_0",
    "chunkText": "So patient centered care is really a model that puts the patient at the center of the health care delivery model and allows health care providers to partner with patients and their families. And thanks to initiatives such as ACR   Imaging 3.0 and RSNA Radiology Cares, it has really become a fixture and radiology."
  },
  {
    "Entities": [
      {
        "Score": 0.8109138607978821,
        "Type": "TITLE",
        "Text": "Patient Centered Care",
        "BeginOffset": 8,
        "EndOffset": 29
      },
      {
        "Score": 0.8763600587844849,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 33,
        "EndOffset": 36
      },
      {
        "Score": 0.9922226071357727,
        "Type": "ORGANIZATION",
        "Text": "Institute of Medicine",
        "BeginOffset": 44,
        "EndOffset": 65
      },
      {
        "Score": 0.9674128293991089,
        "Type": "QUANTITY",
        "Text": "six domains",
        "BeginOffset": 66,
        "EndOffset": 77
      },
      {
        "Score": 0.9967392086982727,
        "Type": "ORGANIZATION",
        "Text": "Institute for Patient and Family Centered Care",
        "BeginOffset": 205,
        "EndOffset": 251
      },
      {
        "Score": 0.8941693902015686,
        "Type": "QUANTITY",
        "Text": "four",
        "BeginOffset": 392,
        "EndOffset": 396
      }
    ],
    "speaker": "spk_0",
    "chunkText": "In fact Patient Centered Care is one of the Institute of Medicine six domains of health care quality along with safe, effective, timely, efficient and equitable care. And within patient centered care, the Institute for Patient and Family Centered Care list for core concepts, which are dignity and respect, information sharing, participation and collaboration. And if you think about it, all four of these concepts could really be applied to radiologists communicating directly with patients."
  },
  {
    "Entities": [
      {
        "Score": 0.9887729287147522,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 171,
        "EndOffset": 174
      },
      {
        "Score": 0.9151372909545898,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 178,
        "EndOffset": 181
      },
      {
        "Score": 0.6634779572486877,
        "Type": "QUANTITY",
        "Text": "a couple of reasons",
        "BeginOffset": 255,
        "EndOffset": 274
      },
      {
        "Score": 0.5929057002067566,
        "Type": "QUANTITY",
        "Text": "Number one",
        "BeginOffset": 276,
        "EndOffset": 286
      },
      {
        "Score": 0.782319188117981,
        "Type": "QUANTITY",
        "Text": "one on",
        "BeginOffset": 319,
        "EndOffset": 325
      },
      {
        "Score": 0.6583947539329529,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 326,
        "EndOffset": 329
      },
      {
        "Score": 0.5592638254165649,
        "Type": "QUANTITY",
        "Text": "number",
        "BeginOffset": 353,
        "EndOffset": 359
      },
      {
        "Score": 0.7039352059364319,
        "Type": "QUANTITY",
        "Text": "two",
        "BeginOffset": 360,
        "EndOffset": 363
      },
      {
        "Score": 0.6982134580612183,
        "Type": "ORGANIZATION",
        "Text": "PHI",
        "BeginOffset": 469,
        "EndOffset": 472
      },
      {
        "Score": 0.8069074749946594,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 478,
        "EndOffset": 481
      },
      {
        "Score": 0.5175687670707703,
        "Type": "DATE",
        "Text": "few",
        "BeginOffset": 733,
        "EndOffset": 736
      },
      {
        "Score": 0.9915686249732971,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 845,
        "EndOffset": 848
      },
      {
        "Score": 0.6869019269943237,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 852,
        "EndOffset": 855
      },
      {
        "Score": 0.9893127083778381,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 933,
        "EndOffset": 936
      },
      {
        "Score": 0.6763625741004944,
        "Type": "QUANTITY",
        "Text": "one patient communication",
        "BeginOffset": 940,
        "EndOffset": 965
      },
      {
        "Score": 0.8951354622840881,
        "Type": "TITLE",
        "Text": "WhatsApp",
        "BeginOffset": 1340,
        "EndOffset": 1348
      },
      {
        "Score": 0.7831835746765137,
        "Type": "QUANTITY",
        "Text": "one simple way",
        "BeginOffset": 1384,
        "EndOffset": 1398
      },
      {
        "Score": 0.9453426599502563,
        "Type": "DATE",
        "Text": "1990s",
        "BeginOffset": 3187,
        "EndOffset": 3192
      },
      {
        "Score": 0.999562680721283,
        "Type": "DATE",
        "Text": "2006",
        "BeginOffset": 3243,
        "EndOffset": 3247
      }
    ],
    "speaker": "spk_0",
    "chunkText": "So there are many different technologies that can enable radiologists to communicate directly with patients. And I've broken it down in the public arena and more private, one on one, um, conversation. So I'm gonna focus mostly on the private channels for a couple of reasons. Number one. They're better facilitators of one on one patient engagement and number two, as long as proper precautions are maintained, HIPAA compliance is possible and allows for discussion on PHI.  So one very simple way that radiologists can practice patient centered care is just by talking to patients. Um, and so these were some of the technologies that can enable that. So in the public arena, social media has received a lot of attention in the last few years, and it can really be a fantastic means to increase patient engagement. But it's less well suited for one on one communication with patients. So technologies that are more better suited for one on one patient communication can be kind of divided into synchronous communication methods and asynchronous communication methods. And so synchronous, obviously, in real time talking on the phone, um, directly meeting with a patient and doing an in person consult to doing a virtual consult. And then asynchronous   are things like email, text messaging and other type, instant  messaging platform like WhatsApp  Um, and then patient portals. And one simple way that patients could be engaged directly by radiologists is just to make our contact information more readily accessible. So doing things like putting phone numbers and or email addresses within reports or, um, made available within the patient portal for patients to be able to contact radiologist directly. And this could be achieved in a number of ways, either by putting it in a template in your dictation software or having it automatically show up within the patient portal when they're viewing reports. So text messages are another option. But while they're very useful for certain things like appointment reminders they are really less effective or trying to explain complex medical topics depictions and back to synchronous communication, um, by far away going to be much more effective for communicating more complex medical topics and imaging findings, Um, and obviously the most effective would be an in person consultbut probably the next most effective would be, ah, virtual consults, and these have been effectively implemented in several places across the country. And there are some vendors that can actually enable this. Before this pandemic, I don't know how widely patients were really having virtual encounters with physicians it was much more rare, something that would have been a much tougher sell for a radiologist have a virtual consult with a patient, given that they probably never met the radiologist before. But I will tell the medicine has been widely implemented. The infrastructure is now more robust and patients, they're probably going to be more accepting that idea. And then finally, um, the last, um, means of communication or patient portals, which is what I'm gonna spend the rest of my time talking about. So patient portals have existed since the 1990s , but really, we're not very widely adopted until 2006 because of the meaningful use incentives. And ever since the implementation of packs, radiologists have been very digital physicians living on computers all day, every day. But most health care systems don't provide a way for patients to be able to communicate with radiologist through the portal."
  },
  {
    "Entities": [
      {
        "Score": 0.9999223351478577,
        "Type": "ORGANIZATION",
        "Text": "American Hospital Association",
        "BeginOffset": 41,
        "EndOffset": 70
      },
      {
        "Score": 0.7932602763175964,
        "Type": "QUANTITY",
        "Text": "over 90%",
        "BeginOffset": 72,
        "EndOffset": 80
      },
      {
        "Score": 0.9971665740013123,
        "Type": "LOCATION",
        "Text": "US",
        "BeginOffset": 84,
        "EndOffset": 86
      },
      {
        "Score": 0.9998863935470581,
        "Type": "QUANTITY",
        "Text": "68%",
        "BeginOffset": 151,
        "EndOffset": 154
      },
      {
        "Score": 0.7247823476791382,
        "Type": "QUANTITY",
        "Text": "few years",
        "BeginOffset": 243,
        "EndOffset": 252
      },
      {
        "Score": 0.8906334042549133,
        "Type": "QUANTITY",
        "Text": "over 50,000 patient",
        "BeginOffset": 398,
        "EndOffset": 417
      },
      {
        "Score": 0.7353874444961548,
        "Type": "QUANTITY",
        "Text": "three month",
        "BeginOffset": 444,
        "EndOffset": 455
      },
      {
        "Score": 0.9801347851753235,
        "Type": "DATE",
        "Text": "2014",
        "BeginOffset": 471,
        "EndOffset": 475
      },
      {
        "Score": 0.7910972833633423,
        "Type": "QUANTITY",
        "Text": "3%",
        "BeginOffset": 510,
        "EndOffset": 512
      },
      {
        "Score": 0.9942409992218018,
        "Type": "DATE",
        "Text": "2014",
        "BeginOffset": 639,
        "EndOffset": 643
      }
    ],
    "speaker": "spk_0",
    "chunkText": "And in ah, 2016-2017  survey done by the American Hospital Association, over 90% of US hospitals offered the ability to view medical records online in 68% allowed patients the same messages to their healthcare providers directly. So this is a few years old, so I imagine that this has gone even up. Um, since then and with specific regard to radiology, um, a large academic health center looked at over 50,000 patient initiated messages over a three month period back in 2014 and they found that approximately 3% of all there messages initiated by patients through the portal were related to radiology studies. And again, this was back in 2014 and it very well may have increased since then."
  },
  {
    "Entities": [
      {
        "Score": 0.9153639078140259,
        "Type": "QUANTITY",
        "Text": "about 1/3",
        "BeginOffset": 162,
        "EndOffset": 171
      }
    ],
    "speaker": "spk_0",
    "chunkText": "So what did they find? Um, this table from their paper and shows all the question types of questions that they received so blow up the most common questions here about 1/3 of them were What are my imaging  results? The next most common question was, What is the next best finding for next best step for such and such finding and followed by? What does this finding mean in my report?"
  },
  {
    "Entities": [
      {
        "Score": 0.8188890218734741,
        "Type": "QUANTITY",
        "Text": "52%",
        "BeginOffset": 193,
        "EndOffset": 196
      },
      {
        "Score": 0.9706467390060425,
        "Type": "DATE",
        "Text": "couple of years ago",
        "BeginOffset": 230,
        "EndOffset": 249
      }
    ],
    "speaker": "spk_0",
    "chunkText": "And while more and more hospitals have been giving patients the opportunity to utilize portable, we really need to be aware of their biases. The adoption rate of patient portals is only around 52% according to in that announced a couple of years ago, and things such as age, race, sex and income all influence the adoption rate by patients of portals, and the people using them tend to be younger, more affluent and white. So there's lots of room for improvement here on something that we needed very much be aware of going forward. We don't want to exclude anybody from the conversation."
  },
  {
    "Entities": [],
    "speaker": "spk_0",
    "chunkText": "So just to kind of frame the question for the problem here. If patient portals are so ubiquitous  and patients are using them"
  },
  {
    "Entities": [
      {
        "Score": 0.42516064643859863,
        "Type": "QUANTITY",
        "Text": "last",
        "BeginOffset": 394,
        "EndOffset": 398
      },
      {
        "Score": 0.3659045994281769,
        "Type": "DATE",
        "Text": "two",
        "BeginOffset": 399,
        "EndOffset": 402
      },
      {
        "Score": 0.5446410775184631,
        "Type": "QUANTITY",
        "Text": "years and decades",
        "BeginOffset": 403,
        "EndOffset": 420
      },
      {
        "Score": 0.6699495315551758,
        "Type": "QUANTITY",
        "Text": "multiple",
        "BeginOffset": 481,
        "EndOffset": 489
      },
      {
        "Score": 0.5730559229850769,
        "Type": "QUANTITY",
        "Text": "several articles",
        "BeginOffset": 602,
        "EndOffset": 618
      }
    ],
    "speaker": "spk_0",
    "chunkText": "and they're using them to message healthcare providers, then why are they not using them to message us, the radiologist. Well, it's really a very simple answer. It's because they can't, uh, the patient portals have been built in such a way that patients are not able to initiate messages to radiologist, and I think a lot of that is our own fault, just the way we set up our practices over the last two years and decades, we've really removed ourselves, Um, from the bed side. And multiple articles in the literature have addressed the value proposition of patient portals in regards to radiology, and several articles even mentioned the possibility of enabling patients to directly communicate look radiologists. But outside of providing contact information within reports like I mentioned earlier, I'm not aware of any widespread use of, um, patient portal systems for radiologists to refer patients to communicate with radiologists."
  },
  {
    "Entities": [
      {
        "Score": 0.7625501155853271,
        "Type": "DATE",
        "Text": "few years ago",
        "BeginOffset": 5,
        "EndOffset": 18
      },
      {
        "Score": 0.8371143937110901,
        "Type": "ORGANIZATION",
        "Text": "EMR",
        "BeginOffset": 79,
        "EndOffset": 82
      },
      {
        "Score": 0.9662282466888428,
        "Type": "ORGANIZATION",
        "Text": "Cincinnati Children's Hospital",
        "BeginOffset": 222,
        "EndOffset": 252
      },
      {
        "Score": 0.9746642112731934,
        "Type": "ORGANIZATION",
        "Text": "Cincinnati Children's",
        "BeginOffset": 611,
        "EndOffset": 632
      },
      {
        "Score": 0.5110657811164856,
        "Type": "ORGANIZATION",
        "Text": "EMR",
        "BeginOffset": 717,
        "EndOffset": 720
      },
      {
        "Score": 0.993187665939331,
        "Type": "ORGANIZATION",
        "Text": "Epic",
        "BeginOffset": 779,
        "EndOffset": 783
      },
      {
        "Score": 0.995872437953949,
        "Type": "ORGANIZATION",
        "Text": "MyChart",
        "BeginOffset": 788,
        "EndOffset": 795
      },
      {
        "Score": 0.9992132782936096,
        "Type": "QUANTITY",
        "Text": "48 hour",
        "BeginOffset": 1030,
        "EndOffset": 1037
      }
    ],
    "speaker": "spk_0",
    "chunkText": "So a few years ago, we came up with this idea to implement a method within our EMR Patient Portal to do just that, to allow patients to communicate with radiologist directly. Um, and this project took place while I was at Cincinnati Children's Hospital and I could not have done it alone. So thank you to everybody involved with the project and we're making a way out.  So I'm gonna kind of describe what we did. And since we like every other healthcare  system, this country, as I previously stated, have a patient portal system. We wanted to work within the confines of that system. And so this took place at Cincinnati Children's, which is a large academic children's hospital  , and as I said, we already have an EMR  with a built-in  patient portal system that happen to be Epic and MyChart . Um, and within the system, patients and proxies were already able to view the reports and things Um, like radiographs, fluoroscopy,    ultrasound, IR and most nuclear medicine study reports were available immediately, but there's a 48 hour embargo period for CT , MRI  , and Pet CT scans."
  },
  {
    "Entities": [
      {
        "Score": 0.9865915775299072,
        "Type": "ORGANIZATION",
        "Text": "EMR Patient Portal",
        "BeginOffset": 109,
        "EndOffset": 127
      }
    ],
    "speaker": "spk_0",
    "chunkText": "So what we did was form a working group consisting radiologists, radiology infomatics , and members from the EMR Patient Portal team. And we kind of figured out what we could and couldn't do and came up with our specifications and then ultimately, um, develop the system."
  },
  {
    "Entities": [
      {
        "Score": 0.9655463099479675,
        "Type": "QUANTITY",
        "Text": "seven items",
        "BeginOffset": 68,
        "EndOffset": 79
      },
      {
        "Score": 0.727311909198761,
        "Type": "QUANTITY",
        "Text": "number one",
        "BeginOffset": 99,
        "EndOffset": 109
      },
      {
        "Score": 0.8463522791862488,
        "Type": "QUANTITY",
        "Text": "both",
        "BeginOffset": 144,
        "EndOffset": 148
      },
      {
        "Score": 0.41666650772094727,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 592,
        "EndOffset": 595
      },
      {
        "Score": 0.9154912233352661,
        "Type": "QUANTITY",
        "Text": "a couple weeks",
        "BeginOffset": 709,
        "EndOffset": 723
      },
      {
        "Score": 0.5649359226226807,
        "Type": "QUANTITY",
        "Text": "lot",
        "BeginOffset": 834,
        "EndOffset": 837
      },
      {
        "Score": 0.998324453830719,
        "Type": "QUANTITY",
        "Text": "five",
        "BeginOffset": 1324,
        "EndOffset": 1328
      },
      {
        "Score": 0.9521116018295288,
        "Type": "QUANTITY",
        "Text": "seven specifications",
        "BeginOffset": 1342,
        "EndOffset": 1362
      }
    ],
    "speaker": "spk_0",
    "chunkText": "So what were those final specifications?  We came up with a list of seven items um listed here. So number one, we wanted it to be available for both completed and upcoming studies. We wanted it to require minimal data entry by patients just to minimize the barrier. Um, and we wanted the ability to initiate the question directly from report, because that's where patients will be likely to have questions. And it was a decision to make the questions go to a pool of radiologists as opposed to individual radiologists who read the studies. And thereare a number of reasons for that. The main one being didn't want radiologists have to be specifically tied to their  inboxes that somebody goes on vacation for a couple weeks we didn't want them to have to constantly be checking messages, and the other thing was that we anticipated a lot of the questions to be able to be answered by, um, pretty much any of the radiologist. Additionally, we wanted the message in response to be available within the EMR so that other providers will be able to view it. We wanted the ability to document phone calls, and we wanted the ability that forwarded questions to other providers outside of radiology in case it was something outside of our area of expertise, which is treatment related questions. And in the end, we were able to get five out of these seven specifications met in the final build, Um, so we weren't quite able to get minimal data entry. There's a little bit more manual data entry than we would have liked, and they weren't able to directly initiate the question from the report. But it's from where they go to view the test results so pretty close."
  },
  {
    "Entities": [
      {
        "Score": 0.8944083452224731,
        "Type": "QUANTITY",
        "Text": "two basic options",
        "BeginOffset": 44,
        "EndOffset": 61
      }
    ],
    "speaker": "spk_0",
    "chunkText": "And so in developing the system, um, we had two basic options available to us for the types of messages that get sent. So there was the get medical advice type and the customer service type, and the get medical advice type is what you use when you go on your portal and send a message to your doctor or your healthcare  provider, and that's messages related directly to the patient healthcare, then the other kind of message is customer service, which is really intended for messages about non-medical  information."
  },
  {
    "Entities": [
      {
        "Score": 0.7038474082946777,
        "Type": "QUANTITY",
        "Text": "each of those",
        "BeginOffset": 46,
        "EndOffset": 59
      },
      {
        "Score": 0.5139731764793396,
        "Type": "ORGANIZATION",
        "Text": "EMR",
        "BeginOffset": 458,
        "EndOffset": 461
      },
      {
        "Score": 0.9462190866470337,
        "Type": "QUANTITY",
        "Text": "two",
        "BeginOffset": 606,
        "EndOffset": 609
      }
    ],
    "speaker": "spk_0",
    "chunkText": "And so some of the challenges associated with each of those types with the get medical advice option with the way that radiology encounters are created within the EMR um, is different than how encounters are created for clinic visits. So because of that, patients aren't able to initiate questions to radiologists and then the customer service messaging option because it was intended for  non-medical use, it didn't create um,  create encounters within the EMR for other providers to be able to view the message or the radiologist response. So what we ended up doing was a combined hybrid solution of the two."
  },
  {
    "Entities": [
      {
        "Score": 0.5308808088302612,
        "Type": "OTHER",
        "Text": "ray renal",
        "BeginOffset": 793,
        "EndOffset": 802
      },
      {
        "Score": 0.5796325206756592,
        "Type": "ORGANIZATION",
        "Text": "EMR",
        "BeginOffset": 1388,
        "EndOffset": 1391
      }
    ],
    "speaker": "spk_0",
    "chunkText": "And here's what it looked like. So this is the test results section for patients when they go into the patient portal and all tests results are lumped together. So radiology reports are nextto the lab results, um, and all other kinds of results, so a little bit  sub-optimal. But that's, uh, the way this system is set up and so you can see this block down here in the bottom right. Um, I'll blow that up here and it says, Ask the radiologist question. If you have a question regarding the recent or future radiology study may send a question to the radiologist. And when they click on that link, they get taken to this, um, this form here. And so this is what I meant by minimal data entry. So the patient or the proxy have to type in the name or the type of the radiology studies. So just X ray renal ultrasound, etcetera. Um, they have to answer whether it was the completed study or a study that had not yet performed. If the type in the date of the study, how they like to be contacted, whether through the portal or by telephone on, uh, the number on which  they want to be contacted. And the question. So once they type in all this information and click the send button, then goes to a pool of radiologists. And as I said previously, it's not related to who read the study, but it goes to the to a whole pool. But, um so this essentially equates to ah, shared in basket within the EMR and because of that, there were worries that multiple people will be looking at messages and duplicating work. So in order to minimize that, there's a button in there, that radiologist can claim a message that we're not duplicating work. And here's what the in basket looks like for the radiologist, list of questions at the top and then the individual question at the bottom. And it contains all the items that the patient entered the type of study when it was completed, how they like to be contacted. And the question so on the radiologist side, um, they're then able to reply to the patient directly from the screen and type of message out through the patient portal, which will then get directly pushed to the patient of the proxy, or they're able to document the phone call. That's how the patient would like to be contacted."
  },
  {
    "Entities": [
      {
        "Score": 0.749233067035675,
        "Type": "QUANTITY",
        "Text": "one of",
        "BeginOffset": 12,
        "EndOffset": 18
      },
      {
        "Score": 0.5836150050163269,
        "Type": "QUANTITY",
        "Text": "requirements",
        "BeginOffset": 23,
        "EndOffset": 35
      },
      {
        "Score": 0.6298478245735168,
        "Type": "QUANTITY",
        "Text": "both",
        "BeginOffset": 202,
        "EndOffset": 206
      },
      {
        "Score": 0.5468122363090515,
        "Type": "QUANTITY",
        "Text": "a few metrics",
        "BeginOffset": 277,
        "EndOffset": 290
      },
      {
        "Score": 0.9515394568443298,
        "Type": "DATE",
        "Text": "end of 2017",
        "BeginOffset": 440,
        "EndOffset": 451
      },
      {
        "Score": 0.997580885887146,
        "Type": "DATE",
        "Text": "July 2018",
        "BeginOffset": 586,
        "EndOffset": 595
      },
      {
        "Score": 0.9960657954216003,
        "Type": "QUANTITY",
        "Text": "88 questions",
        "BeginOffset": 616,
        "EndOffset": 628
      },
      {
        "Score": 0.9994382262229919,
        "Type": "QUANTITY",
        "Text": "15%",
        "BeginOffset": 905,
        "EndOffset": 908
      }
    ],
    "speaker": "spk_0",
    "chunkText": "And so then one of our requirements was that this would then show up within the the chart for other providers to be able to view, and it creates ah, patient email radiology type encounter that includes both the patient message and the response from the radiologist. We tracked a few metrics over time, putting the number of questions, the type of questions the radiologist responsible and the response time We went live with it back in the end of 2017 had several promotions, a time to try to increase awareness of it and between the time of go live and the time of publication, um, in July 2018 received a total of 88 questions, and these are the types of questions received. The most common question was when results will be available and then the next most frequent question, which is really what we were hoping for, was questions about imaging findings, or clarification of imaging findings, and then 15% of our questions were requestto view images."
  },
  {
    "Entities": [
      {
        "Score": 0.9991272687911987,
        "Type": "QUANTITY",
        "Text": "36 faculty",
        "BeginOffset": 141,
        "EndOffset": 151
      },
      {
        "Score": 0.9998405575752258,
        "Type": "QUANTITY",
        "Text": "11 fellows",
        "BeginOffset": 156,
        "EndOffset": 166
      },
      {
        "Score": 0.9989439845085144,
        "Type": "QUANTITY",
        "Text": "33 different radiologists",
        "BeginOffset": 175,
        "EndOffset": 200
      },
      {
        "Score": 0.925344705581665,
        "Type": "QUANTITY",
        "Text": "about 5.1 hours",
        "BeginOffset": 293,
        "EndOffset": 308
      }
    ],
    "speaker": "spk_0",
    "chunkText": "So this is just, ah chart showing the number of messages received going up steadily over time and out of the the time of publication. Out of 36 faculty and 11 fellows, we had 33 different radiologists respond to messages, so we had very good uptake. Ah, pretty quick median turnaround time of about 5.1 hours. And despite the large number of studies we performed, though, the number of questions we received was relatively small"
  },
  {
    "Entities": [
      {
        "Score": 0.9268584251403809,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 39,
        "EndOffset": 42
      },
      {
        "Score": 0.5311105847358704,
        "Type": "QUANTITY",
        "Text": "of our",
        "BeginOffset": 642,
        "EndOffset": 648
      }
    ],
    "speaker": "spk_0",
    "chunkText": "and So just as an example here, um, of one of the questions received, my pediatrician was unsure what was meant by likely represents muscular insertion sites. Could you please elaborate? Pediatrician did say it was nothing necessarily be worried about that. We should watch it for now. Um, another example here of a patient's parents wanting to view the hip ultrasounds from a study done the day before, Um, kind of, uh, premonition of what's become in the next talk and so to wrap it all up. Um, in conclusion, patients are reading our radiology reports in the patient portal, and they expect timely results as expected. Um, but almost half of our questions we're asking when results will be available. So we really need better education, um, regarding our result embargo for the studies that are delayed such a CT, MRI and PET/CT ,"
  },
  {
    "Entities": [
      {
        "Score": 0.934519350528717,
        "Type": "QUANTITY",
        "Text": "second most frequent question",
        "BeginOffset": 8,
        "EndOffset": 37
      }
    ],
    "speaker": "spk_0",
    "chunkText": "and the second most frequent question is really what we were hoping for. As I said, that was questions about imaging findings, and the questions received have been appropriate. Radiologist answer. Not overly burdensome. Um, and it's really been satisfying. And, um, anecdotally, multiple people said that they found it to be a very satisfying endeavor, and patients want to see their images. So in conclusion, the MR  based patient portals can be constructed to enable patient communication directly with radiologists and are good means for radiologists to increase patient engagement. And patients will use it and seem to appreciate it. Thank you."
  },
  {
    "Entities": [
      {
        "Score": 0.9997161030769348,
        "Type": "PERSON",
        "Text": "Morgan",
        "BeginOffset": 37,
        "EndOffset": 43
      }
    ],
    "speaker": "spk_0",
    "chunkText": "A little bit of a slow clap for you, Morgan."
  },
  {
    "Entities": [
      {
        "Score": 0.996321439743042,
        "Type": "PERSON",
        "Text": "Morgan",
        "BeginOffset": 7,
        "EndOffset": 13
      },
      {
        "Score": 0.9842754006385803,
        "Type": "ORGANIZATION",
        "Text": "SIIM",
        "BeginOffset": 209,
        "EndOffset": 213
      },
      {
        "Score": 0.5788846611976624,
        "Type": "QUANTITY",
        "Text": "couple of disclosures",
        "BeginOffset": 227,
        "EndOffset": 248
      }
    ],
    "speaker": "spk_2",
    "chunkText": "Thanks Morgan . I have to say you're gonna be a little bit disappointed cause I'm not going to directly talk about our our image sharing with patients. But I will allude to it and advertise another session at SIIM. I do have a couple of disclosures."
  },
  {
    "Entities": [
      {
        "Score": 0.9894960522651672,
        "Type": "DATE",
        "Text": "today",
        "BeginOffset": 29,
        "EndOffset": 34
      },
      {
        "Score": 0.9960389137268066,
        "Type": "PERSON",
        "Text": "Tessa",
        "BeginOffset": 78,
        "EndOffset": 83
      },
      {
        "Score": 0.8887154459953308,
        "Type": "PERSON",
        "Text": "Morgan",
        "BeginOffset": 88,
        "EndOffset": 94
      },
      {
        "Score": 0.9812015295028687,
        "Type": "QUANTITY",
        "Text": "both",
        "BeginOffset": 100,
        "EndOffset": 104
      },
      {
        "Score": 0.8549471497535706,
        "Type": "ORGANIZATION",
        "Text": "HIMSS",
        "BeginOffset": 375,
        "EndOffset": 380
      },
      {
        "Score": 0.7041110396385193,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 475,
        "EndOffset": 478
      },
      {
        "Score": 0.9842469692230225,
        "Type": "PERSON",
        "Text": "Morgan",
        "BeginOffset": 1247,
        "EndOffset": 1253
      },
      {
        "Score": 0.9501453638076782,
        "Type": "PERSON",
        "Text": "Tessa",
        "BeginOffset": 1258,
        "EndOffset": 1263
      },
      {
        "Score": 0.9578187465667725,
        "Type": "ORGANIZATION",
        "Text": "RSNA",
        "BeginOffset": 1373,
        "EndOffset": 1377
      },
      {
        "Score": 0.9864935874938965,
        "Type": "ORGANIZATION",
        "Text": "ACR",
        "BeginOffset": 1382,
        "EndOffset": 1385
      },
      {
        "Score": 0.7185492515563965,
        "Type": "QUANTITY",
        "Text": "both",
        "BeginOffset": 1396,
        "EndOffset": 1400
      },
      {
        "Score": 0.4903179705142975,
        "Type": "OTHER",
        "Text": "Imaging",
        "BeginOffset": 1462,
        "EndOffset": 1469
      },
      {
        "Score": 0.6658083200454712,
        "Type": "QUANTITY",
        "Text": "Both",
        "BeginOffset": 1484,
        "EndOffset": 1488
      },
      {
        "Score": 0.8910982012748718,
        "Type": "DATE",
        "Text": "today",
        "BeginOffset": 1669,
        "EndOffset": 1674
      },
      {
        "Score": 0.9584919810295105,
        "Type": "ORGANIZATION",
        "Text": "ACR",
        "BeginOffset": 1876,
        "EndOffset": 1879
      },
      {
        "Score": 0.9733976721763611,
        "Type": "ORGANIZATION",
        "Text": "RSNA",
        "BeginOffset": 1884,
        "EndOffset": 1888
      }
    ],
    "speaker": "spk_2",
    "chunkText": "What I hope to do in my talk today is defined patient engagement. I know that Tessa and Morgan have both done so, but I'll share a couple of different definitions and then describe some of the engagement strategies that our department has implemented. I'll share the framework for how we think about patient engagement within our department. I'm through some examples I'm so HIMSS defines patient engagement as providers and patients working together to improve health. That one is to me, is a bit of a flimsy definition. The providers and patients working together is a little bit hard to conceptualize, and it can mean a lot of different things. I prefer this definition that I saw in health affairs and that defines patient engagement as a concept that combined the patient's knowledge, skills and ability to manage his or her own health on that part of the definition to me is really important because it meets the patient at their level, um, and then throws on and cares with interventions designed to increase activation and promote positive patient behavior. And so then you're trying to meet the patient at their level and do things that help them that they are interested in to promote their health. I do like that definition better. As  Morgan and Tessa have eluded the field of radiology, is really pushed towards patient engagement and our large societies like RSNA and ACR      have both launched patient initiatives through Radiology Cares and the Imaging 3.0   series. Both of those initiatives, I think, really are trying to take radiology out of the dark and into the light and getting us out of our reading rooms in front of patients. I hope to share today that not all of it means we have all patient engagement means we have to come out of the dark rooms, but we do need to meet our patients where they want to be. In our in these initiatives, I think the ACR and RSNA  are hoping that our patients get to know us. But I do want to highlight that before our patients could get to know us. We really need to get to know them first."
  },
  {
    "Entities": [
      {
        "Score": 0.5734112858772278,
        "Type": "QUANTITY",
        "Text": "first",
        "BeginOffset": 391,
        "EndOffset": 396
      },
      {
        "Score": 0.7626835703849792,
        "Type": "PERSON",
        "Text": "Morgan",
        "BeginOffset": 567,
        "EndOffset": 573
      },
      {
        "Score": 0.7210859060287476,
        "Type": "QUANTITY",
        "Text": "each of these points",
        "BeginOffset": 797,
        "EndOffset": 817
      },
      {
        "Score": 0.726423442363739,
        "Type": "QUANTITY",
        "Text": "each point",
        "BeginOffset": 872,
        "EndOffset": 882
      },
      {
        "Score": 0.8027032017707825,
        "Type": "PERSON",
        "Text": "Morgan",
        "BeginOffset": 925,
        "EndOffset": 931
      },
      {
        "Score": 0.7782644629478455,
        "Type": "ORGANIZATION",
        "Text": "Twitter",
        "BeginOffset": 1125,
        "EndOffset": 1132
      },
      {
        "Score": 0.7599524855613708,
        "Type": "ORGANIZATION",
        "Text": "Instagram",
        "BeginOffset": 1201,
        "EndOffset": 1210
      }
    ],
    "speaker": "spk_2",
    "chunkText": "So when we think about workflow and um, and the way that we deliver care and radiology, I tend to think about about it as a value stream. And we help a patient move through their imaging from the time and order is thought about all the way through when a bill is placed. But that's really not how a patient thinks about it until we think from a patient's point of view, the imaging study is first ordered, and then a patient will start to research a study. They will then schedule in exam. They arrive for their exam, get the exam. They often will wait for resultsas Morgan alluded to get the results, and then they eventually get billed. Um and some of the follow up that happens later.  to bring it back a full cycle. So I'm gonna touch on several of these points and project that we've used at each of these points to engage patients because of time I won't talk about each point. So we'll start with researching imaging. Morgan alluded to Social media and how social media is used or not used to engage patients. I think what he's getting at is that social media does not equal patient engagement. When we post things on Twitter, we're not going towards the patient as the audience. Same thing on Instagram. The patient is not our audience. So for social media to direct to be directed for patient engagement, the patient needs to be the target audience. In our department we tried to do that through our blog on and so overall, the goal of our blog is to improve education for our patients. Um, and because we're a Children's hospital, the families prior to their visit, um, we have a number of different themes of our blog that we post about regularly these are things like how we do it, what makes us different. How research relates to families, some patients stories and then introducing our team members to our patients. Um, with the how we do it articles, we try to explain our practices to our patients and their families. This is things like, How do you work together to get your autistic child through an MRI? Um, or even what is nuclear medicine?"
  },
  {
    "Entities": [],
    "speaker": "spk_2",
    "chunkText": "What makes us different? What we're striving to do is talk about why a Children's hospital is better for Children, for pediatric patients and the unique features of our department. On so, we talk about how we celebrate patient experience week or using video goggles to help Childrenbe  more still during their imaging."
  },
  {
    "Entities": [
      {
        "Score": 0.9218606352806091,
        "Type": "ORGANIZATION",
        "Text": "SIIM",
        "BeginOffset": 214,
        "EndOffset": 218
      }
    ],
    "speaker": "spk_2",
    "chunkText": "Research, we try really try to frame it as wide. Is the research beneficial for my child, my child with a condition how it affects them now and not not the research to the level of detail that will be presented at SIIM and other conferences? And so the goal with that type of research, um, for the go with those posted to show the groundbreaking"
  },
  {
    "Entities": [
      {
        "Score": 0.8037731647491455,
        "Type": "OTHER",
        "Text": "Neonatal  MRI",
        "BeginOffset": 52,
        "EndOffset": 65
      }
    ],
    "speaker": "spk_2",
    "chunkText": "discoveries that we make. So things like building a Neonatal  MRI   scanner or how we work to get our results faster."
  },
  {
    "Entities": [
      {
        "Score": 0.9731853604316711,
        "Type": "DATE",
        "Text": "10 years later",
        "BeginOffset": 160,
        "EndOffset": 174
      }
    ],
    "speaker": "spk_2",
    "chunkText": "And then patient stories. This is about patient experience and the impact our patients have on us. So this story was about how provide how a patient remembered 10 years later, this technologists caring for them during the trauma or this patient she went, had an MRI and what the MRI   felt like to her."
  },
  {
    "Entities": [],
    "speaker": "spk_2",
    "chunkText": "We also had in this post it was written on her letterhead"
  },
  {
    "Entities": [],
    "speaker": "spk_2",
    "chunkText": "on the meet the team post give the families that awareness of the people caring for them and that it does make a team at all roles throughout the department."
  },
  {
    "Entities": [
      {
        "Score": 0.9446222186088562,
        "Type": "QUANTITY",
        "Text": "both",
        "BeginOffset": 9,
        "EndOffset": 13
      },
      {
        "Score": 0.9352365732192993,
        "Type": "OTHER",
        "Text": "enterovirus",
        "BeginOffset": 192,
        "EndOffset": 203
      },
      {
        "Score": 0.9842615127563477,
        "Type": "ORGANIZATION",
        "Text": "Covid",
        "BeginOffset": 292,
        "EndOffset": 297
      },
      {
        "Score": 0.6364946961402893,
        "Type": "QUANTITY",
        "Text": "single point",
        "BeginOffset": 361,
        "EndOffset": 373
      },
      {
        "Score": 0.9762810468673706,
        "Type": "DATE",
        "Text": "today",
        "BeginOffset": 468,
        "EndOffset": 473
      },
      {
        "Score": 0.9898855090141296,
        "Type": "EVENT",
        "Text": "Banana day",
        "BeginOffset": 477,
        "EndOffset": 487
      },
      {
        "Score": 0.9694823622703552,
        "Type": "EVENT",
        "Text": "Halloween",
        "BeginOffset": 491,
        "EndOffset": 500
      },
      {
        "Score": 0.9916794896125793,
        "Type": "EVENT",
        "Text": "Halloween",
        "BeginOffset": 514,
        "EndOffset": 523
      }
    ],
    "speaker": "spk_2",
    "chunkText": "We tried both at every role, including technologists, child life specialist, administrative assistance and radiologists. We do have other newsworthy topics. So how we don't This was the novel enterovirus in the previous pandemic that that came about. We have tried to actually stay away from Covid  on the blog because we want the hospital to be able to have a single point of discussion around that. We also try to do fun things to engage our pediatric patients like today is Banana day or Halloween candy around Halloween."
  },
  {
    "Entities": [
      {
        "Score": 0.8918852806091309,
        "Type": "QUANTITY",
        "Text": "more than 250,000 page views",
        "BeginOffset": 249,
        "EndOffset": 277
      }
    ],
    "speaker": "spk_2",
    "chunkText": "And we found that it helps to include multimedia or answer specific questions really gets drives  some of that engagement. We have added games that Children have have created and embedded those in our blog . So we found that this is work. We've had more than 250,000 page views on our blog overtime on our top post again answer specific questions for the patient. We've had comments that underscore the impact. So, um answer asking specific questions or thanking them for thanking us for posts and how the post really help their child."
  },
  {
    "Entities": [
      {
        "Score": 0.5664148926734924,
        "Type": "QUANTITY",
        "Text": "four MR  scanners",
        "BeginOffset": 417,
        "EndOffset": 434
      },
      {
        "Score": 0.8956220149993896,
        "Type": "QUANTITY",
        "Text": "Both",
        "BeginOffset": 595,
        "EndOffset": 599
      },
      {
        "Score": 0.9692399501800537,
        "Type": "PERSON",
        "Text": "Ben",
        "BeginOffset": 1185,
        "EndOffset": 1188
      },
      {
        "Score": 0.7407038807868958,
        "Type": "QUANTITY",
        "Text": "one text message",
        "BeginOffset": 1472,
        "EndOffset": 1488
      },
      {
        "Score": 0.9461510181427002,
        "Type": "PERSON",
        "Text": "Ben",
        "BeginOffset": 1854,
        "EndOffset": 1857
      }
    ],
    "speaker": "spk_2",
    "chunkText": "On the get exam portion. Um, we are blessed that our hospital is being able to build a new tower that's in the image on the left. It's currently under construction on the image on the right, and but while this is cool and it's going to add new capabilities for us, that new tower is going up. The there's the blueprints for the ground floor is going up immediately adjacent at the bottom to our MR  scanners. We have four MR  scanners on this wall, and that's causing significant effects. As the steel beams move across. There's vibrations and beams banging in cause magnetic field differences. Both of those can lead to image quality degradation. And so   we had to prepare for that. We had a modular unit for MRI   built which was distant from the site of construction, and we needed a way to tell patients that this new site was available and that their imaging would be performed there. It is present in the instructions to patients, but we know that the instructions were confusing and patients often don't read them. So we built a text messaging application using pre where components. This is an example. After logging and the technologist entered the patient's phone number on Ben, we have a standard text template. We have multiple templates that the technologists can choose, depending on the scenario, and we can add more templates, Um, and so it's basically entering the phone number clicking Send message and you get a text in the text. We had to keep it toe one text message for people that have to pay for individual texts. We wanted to make sure that the address was there and was clickable so that it could be integrated into the map applications on patient on family smartphones. The phone number is clickable, so When patients have questions, they get to the new location number and can get directions that they're calling on phone on Ben. We have a link that goes to a blood post, which has more frequently asked questions, including a map for people who have different applications."
  },
  {
    "Entities": [
      {
        "Score": 0.9044415950775146,
        "Type": "QUANTITY",
        "Text": "two things",
        "BeginOffset": 555,
        "EndOffset": 565
      },
      {
        "Score": 0.8223572373390198,
        "Type": "QUANTITY",
        "Text": "first",
        "BeginOffset": 571,
        "EndOffset": 576
      },
      {
        "Score": 0.5122007131576538,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 601,
        "EndOffset": 604
      },
      {
        "Score": 0.6624883413314819,
        "Type": "DATE",
        "Text": "last couple of weeks",
        "BeginOffset": 1129,
        "EndOffset": 1149
      }
    ],
    "speaker": "spk_2",
    "chunkText": "Next is when patients are waiting and, in this sense, families waiting for their child to get, um, anesthesia during imaging. And when your child is under anesthesia, it's always a stressful time. Your child is away from you and undergoing a medical procedure on, and families are understandably nervous. And we needed a way to help our families know where their child was in the process as they were going, and to get real time updates at the same time, we couldn't provide those updates continuously in the waiting room is at some distance, so we built two things. The first is a status board. This one is pretty simple. It shows a unique identifier. It's color and icon based. The orange color says that the imaging is happening. The lilac color, a very distinct different color, says that you're ready for the patient now that we're ready for the patient to come back, and the different icons have meaning for the patient about where they are in the process again. It's very simple. It's not the most, um, the most beautiful user interface, but but it helps us to get the job done and provide those real time updates. In the last couple of weeks, we've also integrated the status board into our hospitals. Mobile application on DSO During this time, um, the front desk staff gives a unique identifier that it's entered into that top field. The family enters their child's date of birth in the bottom field and then click the see visit status. That status is updated in real time. Um, we have just a few statuses, so exam begun exam ended, um, and then ready for visitors. And as the child moves through the process when they hit the ready for visitors, that information is ready in. The parents know that they can come back to the post anesthesia care unit to see their child. Um, of course, it's not just in the appetite to notifications within the bones, so you see that you have an update and can read it"
  },
  {
    "Entities": [
      {
        "Score": 0.8676271438598633,
        "Type": "ORGANIZATION",
        "Text": "Morgan",
        "BeginOffset": 41,
        "EndOffset": 47
      },
      {
        "Score": 0.9568192958831787,
        "Type": "ORGANIZATION",
        "Text": "SIIM",
        "BeginOffset": 177,
        "EndOffset": 181
      },
      {
        "Score": 0.7094290256500244,
        "Type": "QUANTITY",
        "Text": "400",
        "BeginOffset": 203,
        "EndOffset": 206
      },
      {
        "Score": 0.811206042766571,
        "Type": "QUANTITY",
        "Text": "one",
        "BeginOffset": 213,
        "EndOffset": 216
      }
    ],
    "speaker": "spk_2",
    "chunkText": "finally, on giving results. This is what Morgan alluded to and how we've image enabled our patient portal. I am not going to talk about that. We have a separate presentation at SIIM. It's in session, um 400 to as one of the enterprise imaging applied in dramatics presentations. So I encourage you to check that out. It is an exciting project."
  },
  {
    "Entities": [
      {
        "Score": 0.8023871779441833,
        "Type": "QUANTITY",
        "Text": "each step",
        "BeginOffset": 256,
        "EndOffset": 265
      },
      {
        "Score": 0.9994402527809143,
        "Type": "PERSON",
        "Text": "Tim O Connor",
        "BeginOffset": 387,
        "EndOffset": 399
      },
      {
        "Score": 0.8364826440811157,
        "Type": "QUANTITY",
        "Text": "three excellent talks",
        "BeginOffset": 439,
        "EndOffset": 460
      },
      {
        "Score": 0.991201639175415,
        "Type": "DATE",
        "Text": "today",
        "BeginOffset": 491,
        "EndOffset": 496
      }
    ],
    "speaker": "spk_2",
    "chunkText": "So in conclusion, I think that patient engagement requires listening to patients as well as a desire to make changes to suit their needs. There are also many opportunities to increase engagement throughout the imaging process. I find it helpful to look at each step of the process and figure out how we can implement solutions to help our patients. Thank you. Come on now. Turn it back. Tim O Connor, to finish up. As promised. Those were three excellent talks. Thank you all for joining us today on the didactic portion of our session."
  }
];
}
